import React from 'react'
import './Custom_design.css'

const Custom_design = () => {
    const customdata = [
        {
            image: '/assets/images/enggagement/custom-design/ringpng01.png',
            title: 'Share Your Vision',
            content: 'Tell us your story, your style, and your expectations. Whether you have a clear design in mind or just an idea, our team will guide you from concept to creation — selecting the right diamond, setting, and finish to craft a ring that reflects your commitment perfectly.',
        },
        {
            image: '/assets/images/enggagement/custom-design/ringpng02.avif',
            title: 'Design & Consultation',
            content: 'Our design consultation is a personalized process where we understand your preferences, budget, and diamond requirements.',
        },
        {
            image: '/assets/images/enggagement/custom-design/ringpng03.avif',
            title: 'Made to order',
            content: 'Each ring is crafted exclusively for you. From diamond selection to final polishing, every detail is carefully executed after your approval — ensuring a piece that is precise, personal, and made to last a lifetime.',
        }
    ];
    return (
        <>
            <section className='Custom_designsec'>
                <div className='container p-0'>
                    <h5 className='customtitle'>The Custom Design Process </h5>
                    <div className='row mt-4'>
                        {customdata.map((data, index) => (
                            <div className='col-lg-4 col-sm-6 col-12 mx-auto mb-4'>
                                <div className='customdiv'>
                                    <img className='customimg' src={data.image} alt="custom-design" />
                                    <h6 className='customh6'>{data.title}</h6>
                                    <p className='customp'>{data.content}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}

export default Custom_design